var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.86041 0H13.7208V2.2868H6.86041V0ZM9.14721 14.8642V8.00381H11.434V14.8642H9.14721ZM18.3287 7.29489L19.9524 5.67126C19.4607 5.08813 18.9233 4.53929 18.3402 4.05906L16.7165 5.68269C14.9443 4.26488 12.7146 3.41876 10.2906 3.41876C4.60791 3.41876 0 8.02667 0 13.7094C0 19.3921 4.59647 24 10.2906 24C15.9848 24 20.5812 19.3921 20.5812 13.7094C20.5812 11.2968 19.7351 9.06716 18.3287 7.29489ZM2.2868 13.7208C2.2868 18.1458 5.86565 21.7246 10.2906 21.7246C14.7156 21.7246 18.2944 18.1458 18.2944 13.7208C18.2944 9.29586 14.7156 5.71701 10.2906 5.71701C5.86565 5.71701 2.2868 9.29586 2.2868 13.7208Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.e8d30b6aa9abeae50accc5415436f0a5.svg";
export { ForwardRef as ReactComponent };